/**
 * mSTEM mock share link helper (PRJ-04 / LLD UC 11).
 *
 * Generates a fake `https://mstem.mobifone.vn/share/<8char>` URL when the
 * user hits "Xác nhận chia sẻ" in ShareProjectModal. Pure UI mock — BE team
 * will replace this with a real link-generation API endpoint.
 *
 * Clipboard strategy (T-03-01-02 acceptable):
 *   1. Prefer `navigator.clipboard.writeText` (Chrome 66+, Firefox 63+,
 *      Safari 13.1+, Edge — covers LLD NFR V.3 browser matrix).
 *   2. Fall back to a hidden <textarea> + document.execCommand('copy') for
 *      browsers that block the async clipboard API in non-HTTPS contexts.
 *   3. Reject the returned promise on both failure paths so the caller can
 *      surface a toast.
 */

const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';
const SHARE_URL_PREFIX = 'https://mstem.mobifone.vn/share/';
const ID_LENGTH = 8;

const generateId = function () {
    let id = '';
    for (let i = 0; i < ID_LENGTH; i++) {
        id += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
    }
    return id;
};

const buildShareLink = function () {
    return SHARE_URL_PREFIX + generateId();
};

const copyToClipboard = function (text) {
    if (typeof navigator !== 'undefined' &&
        navigator.clipboard &&
        navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
    }
    return new Promise((resolve, reject) => {
        try {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            const success = document.execCommand('copy');
            document.body.removeChild(textarea);
            return success ? resolve() : reject(new Error('execCommand returned false'));
        } catch (e) {
            return reject(e);
        }
    });
};

export {
    SHARE_URL_PREFIX,
    generateId,
    buildShareLink,
    copyToClipboard
};
